import type React from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const ArrowTopRight: React.FC<IconProps> = ({ ...props }) => (
  <BaseIcon {...props}>
    <path d="M10.7573 8.22168C10.7573 8.77396 11.205 9.22168 11.7573 9.22168L21.3641 9.22168L7.51457 23.0712C7.12405 23.4617 7.12405 24.0949 7.51457 24.4854C7.9051 24.8759 8.53826 24.8759 8.92879 24.4854L22.7781 10.636L22.7781 20.2425C22.7781 20.7948 23.2258 21.2425 23.7781 21.2425C24.3304 21.2425 24.7781 20.7948 24.7781 20.2425V8.22171C24.7781 7.93585 24.6582 7.67801 24.4659 7.49576C24.2866 7.32588 24.0445 7.22168 23.7781 7.22168H11.7573C11.205 7.22168 10.7573 7.66939 10.7573 8.22168Z" />
  </BaseIcon>
);
